import {pages} from "../../../shared/constants/pages";
import routesNames from "../../../shared/constants/router";
import svgIcons from "../../../shared/constants/icons/svg-icons";
import permissions from "../../../shared/constants/permissions";
import roles from "../../../shared/constants/roles";

const scopeSettings = [
  {
    text: pages.scopeSettingDashboard.help_page,
    icon: svgIcons.help_center,
    routeName: routesNames.administration.helpConfig,
    permissions: [permissions.readHelpContents, permissions.writeHelpContents],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.error_page,
    icon: svgIcons.exclamation,
    routeName: routesNames.administration.errorConfig,
    permissions: [permissions.writeTranslation],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.maintenance_page,
    icon: svgIcons.maintenance,
    routeName: routesNames.administration.maintenanceConfig,
    permissions: [permissions.writeTranslation],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.email_template_page,
    icon: svgIcons.envelope_open_text,
    routeName: routesNames.administration.emailTemplate,
    permissions: [permissions.writeEmailTemplate, permissions.readEmailTemplate],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.nav_credentials,
    icon: svgIcons.webServices,
    routeName: routesNames.administration.navCredentials,
    permissions: [
      permissions.writeScopeNavCredentials,
      permissions.readScopeNavCredentials,
      permissions.readScope,
      permissions.writeScope
    ],
    applicationOptions: ['timesheets']
  },
  {
    text: pages.scopeSettingDashboard.mail_credentials,
    icon: svgIcons.at,
    routeName: routesNames.administration.mailCredentials,
    permissions: [
      permissions.writeScopeMailCredentials,
      permissions.readScopeMailCredentials,
      permissions.readScope,
      permissions.writeScope
    ],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.emails,
    icon: svgIcons.plane_paper,
    routeName: routesNames.administration.scopeEmails,
    permissions: [
      permissions.writeScopeEmails,
      permissions.readScopeEmails,
      permissions.readScope,
      permissions.writeScope
    ],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.connectivity_test,
    icon: svgIcons.wifi,
    routeName: routesNames.administration.connectivityTest,
    roles: [roles.LOCAL_ADMIN, roles.SUPER_ADMIN],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.policies,
    icon: svgIcons.policies,
    routeName: routesNames.administration.policies,
    roles: [roles.LOCAL_ADMIN, roles.SUPER_ADMIN],
    applicationOptions: ['timesheets', 'invoices']
  },
  {
    text: pages.scopeSettingDashboard.sms_page,
    icon: svgIcons.chat,
    routeName: routesNames.administration.sms,
    permissions: [permissions.writeSmsTemplate, permissions.readSmsTemplate, permissions.readSmsHistory],
    applicationOptions: ['timesheets']
  },
  {
    text: pages.scopeSettingDashboard.timesheet_config_page,
    icon: svgIcons.timesheet_config_page,
    routeName: routesNames.administration.timesheetConfig,
    permissions: [permissions.writeTimesheetConfig],
    applicationOptions: ['timesheets']
  },
  {
    text: pages.scopeSettingDashboard.config_cron_page,
    icon: svgIcons.config_cron,
    routeName: routesNames.administration.cronConfig,
    permissions: [permissions.writeTimesheetConfig],
    applicationOptions: ['timesheets']
  },
  {
    text: pages.scopeSettingDashboard.invoices,
    icon: svgIcons.invoices,
    routeName: routesNames.administration.invoices,
    applicationOptions: ['invoices']
  },
];

export default scopeSettings;
